[
  {
    "id": "demo-burger-house",
    "name": "Burger House",
    "nameAr": "برغر هاوس",
    "aliases": ["burgerhouse", "burger house restaurant", "برجر هاوس"],
    "menuUrl": "https://example.com/menu",
    "location": "Demo location",
    "phone": "",
    "category": "Burgers",
    "description": "Demo restaurant used to test local image matching.",
    "coverImage": "/reference-images/demo-burger-house/sign-main.svg",
    "active": true,
    "order": 1
  },
  {
    "id": "demo-cedar-kitchen",
    "name": "Cedar Kitchen",
    "nameAr": "مطبخ الأرز",
    "aliases": ["cedar", "cedar restaurant", "مطبخ الارز"],
    "menuUrl": "https://example.com/menu",
    "location": "Demo location",
    "phone": "",
    "category": "Lebanese",
    "description": "Demo restaurant used to test local image matching.",
    "coverImage": "/reference-images/demo-cedar-kitchen/sign-main.svg",
    "active": true,
    "order": 2
  }
]
